export function shouldLoadPetitionStarterUpdates() {
	return true;
}
